import Axios, * as others from 'axios';
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';
import React, { Component,useEffect, useState } from "react";
import './ourteam.css';
import { Link } from 'react-router-dom';

const Ourteam = () => {
  const [OurteamData, setOurteamData] = useState(null); // เปลี่ยนจาก [] เป็น null
  const [OurteamLoading, setOurteamLoading] = useState(true);
  const [errorOurteam, setOurteamError] = useState(null);

   useEffect(() => {
    const fetchOurteamData = async () => {
      try {
        const response = await Axios.get(`${URL}api/Ourteam/getourteamsDataPicture`);
        //console.log('Response:', response.data);
        setOurteamData(response.data);
        setOurteamLoading(false);
      } catch (error) {
        console.log('Error:', error);
        setOurteamError(error);
        setOurteamLoading(false);
      }
    };

    fetchOurteamData();
  }, []);

  if (OurteamLoading) {
    return <div>Loading...</div>;
  }

  if (errorOurteam) {
    return <div>Error: {errorOurteam.message}</div>;
  }
  
return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="ourteam" className="a-breadcrumbs">ทีมงานสหกรณ์</a>
            </div>
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-md-offset-1">
              <h2 className="title-section mb-0 mt-0 text-center">
                <span>ทีมงานสหกรณ์</span>
              </h2>
              <div className="divider mb-20 mt-25 gray" />
            </div>
          </div>

          <div className="row mt-0 cws-multi-col" style={{ display: "flex", justifyContent: "center" }}>
            {OurteamData && OurteamData.attachfile ? (
              <div className="profile-item" style={{border: 0}}>
                <div className="pic" style={{ display: "flex", justifyContent: "center" }}>
                  <img 
                    src={`${IMGPATHS}img/OurTeam/${OurteamData.attachfile}`}
                    style={{
                      maxWidth: '100%', 
                      border: '1px solid #e6e6e6', 
                      borderRadius: 8
                    }}
                    alt="Team"
                  />
                </div>
              </div>
            ) : (
              <div className="col-12 text-center">
                <p>ไม่พบข้อมูล</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Ourteam;